package com.milta.core.localization.translations.sq

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Duke ngarkuar…",
    errorNoConnection = "Nuk mund të kontaktohet serveri — kontrollo lidhjen tënde.",
    errorGeneric = "Ndodhi një gabim. Provo përsëri më vonë.",
    contractLockedNotice = "🔒 Kontrata e daljes (format JSON) mbetet e kyçur — shtohet automatikisht nga serveri pas tekstit të redaktuar, që nxjerrja në prodhim të mos prishet kurrë.",
    notModifiedLabel = "Vlera e paracaktuar — kurrë e modifikuar",
    modifiedOnPrefix = "Modifikuar më",
    resetToDefaultAction = "↺ Rikthe te vlerat e paracaktuara",
    editableBodyLabel = "✏️ Përmbajtje e redaktueshme — rregulla biznesi",
    markdownBoldSnippet = "**tekst i trashë**",
    markdownItalicSnippet = "*tekst kursiv*",
    markdownCodeSnippet = "`kod`",
    markdownHeadingSnippet = "## Titull",
    markdownBulletSnippet = "- element liste",
    markdownNumberedSnippet = "1. element liste",
    markdownQuoteSnippet = "> citim",
    previewToggleEdit = "✏️ Redakto",
    previewToggleShow = "👁 Parashiko",
    contractFooterLabel = "🔒 Kontrata e daljes — e kyçur, shtuar automatikisht",
    actionErrorOffline = "Dështoi — kontrollo lidhjen tënde.",
    actionErrorGeneric = "Ruajtja dështoi, provo përsëri.",
    unsavedChangesNotice = "● Ndryshime të paruajtura",
    savingAction = "Duke ruajtur…",
    saveAction = "Ruaj ndryshimet",
)
